module.exports = __webpack_public_path__ + "static/media/kh.7d145a4c.svg";